import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import culture from '../../assets/image/strategy-organization/culture.jpg'
export default class change_management extends Component {
    render() {
        const image=[
            {image:culture}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner bread_crum={['Strategy and Organization','Change Management & Culture']} image={image} title="Change Management & Culture" subtitle=""/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                ”We help our clients in identifying their pressing change issues, prioritizing and executing the areas for improvement in order to shape the organization and strengthen the business.”
                                <br/><br/>
                                …through
                                <br/><br/>
                                Culture Assessment
                                <br/><br/>
                                The very basic foundation in an organization is their culture. Culture will shape the organization’s decision, policy and the way they treat their customer. It is crucial for the organization to identify and nurture their culture.
                                <br/><br/>
                                Core Value Development
                                <br/><br/>
                                Core values are the elements of organization’s culture. Core value will guide the employee on what to do and what not to do.
                                <br/><br/>
                                Change Management
                                <br/><br/>
                                In responding to the new challenge the organization faced, variety of systems, technology, concepts and products have to be implemented in the organization. An effective change management process have to guide all the new implementation in the organization. As the experience say, the real cause of failure in implementing new system is not the system it self, but poor change management initiatives.
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
